import React, { useMemo } from 'react';
import { Link, useParams } from 'react-router-dom';
import { ActivityCard, ContentSection, HeadSection, LoadingImage, TitleText } from '../styles';
import SVGIcon from '../../../../assets/images/svg/SVGIcon';
import { ROUTES } from '../../../../routes/urls';
import ActivityTimelineComponent from '../activityTimeline';
import { categorizeActivityLogs } from '../activityUtils';
import { rootStore } from '../../../../mobx/rootStore';
import { observer } from 'mobx-react-lite';
import ReportTimelineLoading from '../../../../component/loading/reportTimeLineLoading';
import EmptyStateV2 from '../../../../component/emptyState';
import { EMPTY_STATE_SIZE, ICON_SIZE } from '../../../../global/constants';
import { ProjectActivityProps } from '../../../../interfaces/ProjectInterface';

function ProjectActivityCard(props: ProjectActivityProps) {
  const { loading } = props;
  const { id } = useParams<{ id: string }>();
  // mobx variables
  const { projectStore } = rootStore;
  const { currentProject } = projectStore;

  // Categorize activity logs in a single pass using shared helper
  const categorizedLogs = useMemo(
    () => categorizeActivityLogs(currentProject?.activityLogs || []),
    [currentProject?.activityLogs]
  );

  return (
    <ActivityCard isProjectActivityCard={true}>
      <HeadSection>
        <TitleText>Recent activity</TitleText>
        {currentProject?.activityLogs && currentProject?.activityLogs?.length > 0 && (
          <Link to={ROUTES.ALL_ACTIVITIES.replace(':id', id)} className='see-all-link'>
            See all
            <SVGIcon
              name='updated-right-arrow-icon'
              width={ICON_SIZE.SM}
              height={ICON_SIZE.SM}
              viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
              fill='var(--text-primary)'
            />
          </Link>
        )}
      </HeadSection>
      {(!currentProject?.activityLogs || currentProject?.activityLogs?.length === 0) && loading && (
        <LoadingImage>
          <ReportTimelineLoading isProjectOverView={true} />
        </LoadingImage>
      )}
      {(!currentProject?.activityLogs || currentProject?.activityLogs?.length === 0) && !loading && (
        <LoadingImage>
          <EmptyStateV2
            size={EMPTY_STATE_SIZE.SMALL}
            imageUrl={'gif_empty'}
            description='No data found'
            isAlignedCenter={true}
          />
        </LoadingImage>
      )}
      {currentProject?.activityLogs && currentProject?.activityLogs?.length > 0 && (
        <ContentSection>
          <ActivityTimelineComponent title='Today' activities={categorizedLogs.today} />
          <ActivityTimelineComponent title='This week' activities={categorizedLogs.week} />
          <ActivityTimelineComponent title='This month' activities={categorizedLogs.month} />
          <ActivityTimelineComponent title='Older' activities={categorizedLogs.older} />
        </ContentSection>
      )}
    </ActivityCard>
  );
}

export default observer(ProjectActivityCard);
